import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-21ddc453")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " @ ", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteInvoiceDialog = _resolveComponent("DeleteInvoiceDialog")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InvoiceMovementsFilters = _resolveComponent("InvoiceMovementsFilters")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_CurrencyText = _resolveComponent("CurrencyText")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DeleteInvoiceDialog, {
      invoiceId: _ctx.displayDeletingDialog,
      visible: _ctx.displayDeletingDialog,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayDeletingDialog = $event)),
      onDeleted: _ctx.onDeleted
    }, null, 8, ["invoiceId", "visible", "onDeleted"]),
    _createElementVNode("header", null, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('invoiceMovement.list.title')), 1),
      _createVNode(_component_router_link, { to: _ctx.newRoute }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, {
            icon: "pi pi-plus",
            label: "New"
          })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createVNode(_component_InvoiceMovementsFilters, {
      filters: _ctx.advFilters,
      "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.advFilters = $event)),
      onChange: _ctx.onFiltersChange,
      storage: _ctx.SessionStorageEnum.INVOICE_MOVEMENTS_ADVANCED_FILTERS
    }, null, 8, ["filters", "onChange", "storage"]),
    _createVNode(_component_AppTable, {
      ref: "dataTable",
      "striped-rows": false,
      filtersSchema: _ctx.filters,
      service: _ctx.service,
      stateKey: _ctx.stateKey,
      sortField: `created_at`,
      sortOrder: 1,
      showActions: false,
      onResetFilters: _ctx.onReset
    }, {
      columns: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "id",
          header: "Id"
        }),
        _createVNode(_component_Column, { header: "Created at" }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_DateFormatted, {
              date: data.created_at,
              format: "YYYY-MM-DD"
            }, null, 8, ["date"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          class: "center",
          header: "Fee driver"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_CurrencyText, {
              modelValue: data.tot_fee_driver
            }, null, 8, ["modelValue"]),
            (data.tot_fee_driver)
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "button",
                  icon: "pi pi-download",
                  class: "p-button-outlined",
                  disabled: _ctx.requestPending,
                  onClick: ($event: any) => (_ctx.downloadInvoices(data.id, 'DR'))
                }, null, 8, ["disabled", "onClick"])), [
                  [_directive_tooltip, 'Download invoice']
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          class: "center",
          header: "Fee broker"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_CurrencyText, {
              modelValue: data.tot_fee_broker
            }, null, 8, ["modelValue"]),
            (data.tot_fee_broker)
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "button",
                  icon: "pi pi-download",
                  class: "p-button-outlined",
                  disabled: _ctx.requestPending,
                  onClick: ($event: any) => (_ctx.downloadInvoices(data.id, 'BR'))
                }, null, 8, ["disabled", "onClick"])), [
                  [_directive_tooltip, 'Download invoice']
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          class: "center",
          header: "Fee customer"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_CurrencyText, {
              modelValue: data.tot_fee_customer
            }, null, 8, ["modelValue"]),
            (data.tot_fee_customer)
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "button",
                  icon: "pi pi-download",
                  class: "p-button-outlined",
                  disabled: _ctx.requestPending,
                  onClick: ($event: any) => (_ctx.downloadInvoices(data.id, 'CU'))
                }, null, 8, ["disabled", "onClick"])), [
                  [_directive_tooltip, 'Download invoice']
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          class: "center",
          header: "Fee system"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_CurrencyText, {
              modelValue: data.tot_fee_system
            }, null, 8, ["modelValue"]),
            (data.tot_fee_system)
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "button",
                  icon: "pi pi-download",
                  class: "p-button-outlined",
                  disabled: _ctx.requestPending,
                  onClick: ($event: any) => (_ctx.downloadInvoices(data.id, 'SY'))
                }, null, 8, ["disabled", "onClick"])), [
                  [_directive_tooltip, 'Download invoice']
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          class: "center",
          header: "Price client"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_CurrencyText, {
              modelValue: data.tot_price_client
            }, null, 8, ["modelValue"]),
            (data.tot_price_client)
              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "button",
                  icon: "pi pi-download",
                  class: "p-button-outlined",
                  disabled: _ctx.requestPending,
                  onClick: ($event: any) => (_ctx.downloadInvoices(data.id, 'CL'))
                }, null, 8, ["disabled", "onClick"])), [
                  [_directive_tooltip, 'Download invoice']
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { header: "Client" }, {
          body: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.client.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { header: "Period" }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_DateFormatted, {
              date: data.from_period_at,
              format: "YYYY-MM-DD"
            }, null, 8, ["date"]),
            _hoisted_2,
            _createVNode(_component_DateFormatted, {
              date: data.to_period_at,
              format: "YYYY-MM-DD"
            }, null, 8, ["date"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { class: "center" }, {
          body: _withCtx(({ data }) => [
            _withDirectives(_createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-download",
              class: "p-mt-0 p-button-outlined",
              disabled: _ctx.requestPending,
              onClick: ($event: any) => (_ctx.downloadInvoices(data.id))
            }, null, 8, ["disabled", "onClick"]), [
              [_directive_tooltip, 'Download invoices']
            ]),
            _createVNode(_component_Button, {
              type: "button",
              label: "Delete",
              icon: "pi pi-trash",
              disabled: _ctx.requestPending,
              class: "p-button-danger",
              onClick: ($event: any) => (_ctx.deleteMovement(data.id))
            }, null, 8, ["disabled", "onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["filtersSchema", "service", "stateKey", "onResetFilters"])
  ]))
}